export const loadingPlaceholderClassName = 'smart-link-loading-placeholder';
